import { GlobalData } from "../Common/GlobalData";
import { TemplateHelpers, ValueSwapHelper } from "../Common/KendoHelpers";
import { StockPickList } from "../Common/StockPickList";

export class MovingAverages {
    private static readonly GRID = '#grid';

    private static readonly PERCENT_FIELDS = [
        'fiftyDayAvgVolPct',
        'tenDaySmaPct',
        'twentyOneDayEmaPct',
        'fiftyDaySmaPct',
        'twoHundredDaySmaPct',
        'fiftyTwoWkHighPct',
        'fiftyTwoWkLowPct'
    ];
    private static readonly DOLLAR_FIELDS = [
        'volume',
        'tenDaySma',
        'twentyOneDayEma',
        'fiftyDaySma',
        'twoHundredDaySma',
        'fiftyTwoWkHigh',
        'fiftyTwoWkLow'
    ];

    private readonly symbolLink = 'MovingAveragesHistory?symbol=';

    constructor() {
        this.init();
    }

    private init() {
        $('[name=valueSwap]').on('change', (event: any) => {
            if (event.currentTarget.value == '0') {
                ValueSwapHelper.showHideFields(MovingAverages.GRID,
                    MovingAverages.PERCENT_FIELDS, MovingAverages.DOLLAR_FIELDS);
            } else {
                ValueSwapHelper.showHideFields(MovingAverages.GRID,
                    MovingAverages.DOLLAR_FIELDS, MovingAverages.PERCENT_FIELDS);
            }
        });

        const stockPickList = new StockPickList(MovingAverages.GRID,
            GlobalData.URL_SUFFIX_TECHNICAL_REPORTS_MOVING_AVERAGES);

        $(MovingAverages.GRID).kendoGrid({
            dataSource: new kendo.data.DataSource(stockPickList.getDataSourceOptions()),
            height: 915,
            groupable: false,
            sortable: true,
            pageable: false,
            columns: [{
                field: 'symbol',
                title: 'Symbol',
                width: '90px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: TemplateHelpers.getSymbolLinkTemplate(this.symbolLink),
            }, {
                field: 'companyName',
                title: 'Company Name',
                width: '220px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12-left' },
                attributes: { 'class': 'table-cell grid-cell-left' },
            }, {
                field: 'close',
                title: 'Close',
                width: '90px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                format: '{0:c2}',
            }, {
                field: 'volume',
                title: 'Volume $',
                width: '90px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                format: '{0:n0}',
            }, {
                field: 'fiftyDayAvgVolPct',
                title: 'Volume %',
                width: '90px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: kendo.template(TemplateHelpers.getColorPercentTemplate('fiftyDayAvgVolPct')),
            }, {
                field: 'tenDaySma',
                title: '10-Day<br>SMA $',
                width: '90px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                format: '{0:c2}',
            }, {
                field: 'tenDaySmaPct',
                title: '10-Day<br>SMA %',
                width: '90px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: kendo.template(TemplateHelpers.getColorPercentTemplate('tenDaySmaPct')),
            }, {
                field: 'twentyOneDayEma',
                title: '21-Day<br>EMA $',
                width: '90px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                format: '{0:c2}',
            }, {
                field: 'twentyOneDayEmaPct',
                title: '21-Day<br>EMA %',
                width: '90px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: kendo.template(TemplateHelpers.getColorPercentTemplate('twentyOneDayEmaPct')),
            }, {
                field: 'fiftyDaySma',
                title: '50-Day<br>SMA $',
                width: '90px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                format: '{0:c2}',
            }, {
                field: 'fiftyDaySmaPct',
                title: '50-Day<br>SMA %',
                width: '90px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: kendo.template(TemplateHelpers.getColorPercentTemplate('fiftyDaySmaPct')),
            }, {
                field: 'twoHundredDaySma',
                title: '200-Day<br>SMA $',
                width: '90px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                format: '{0:c2}',
            }, {
                field: 'twoHundredDaySmaPct',
                title: '200-Day<br>SMA %',
                width: '90px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: kendo.template(TemplateHelpers.getColorPercentTemplate('twoHundredDaySmaPct')),
            }, {
                field: 'fiftyTwoWkHigh',
                title: '52-Wk<br>High $',
                width: '90px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                format: '{0:c2}',
            }, {
                field: 'fiftyTwoWkHighPct',
                title: '52-Wk<br>High %',
                width: '90px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: kendo.template(TemplateHelpers.getColorPercentTemplate('fiftyTwoWkHighPct')),
            }, {
                field: 'fiftyTwoWkLow',
                title: '52-Wk<br>Low $',
                width: '90px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                format: '{0:c2}',
            }, {
                field: 'fiftyTwoWkLowPct',
                title: '52-Wk<br>Low %',
                width: '90px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                template: kendo.template(TemplateHelpers.getColorPercentTemplate('fiftyTwoWkLowPct')),
            }, {
                field: 'ma_Rank',
                title: 'Rank',
                width: '90px',
                headerAttributes: { 'class': 'table-header-cell grid-header-12' },
                attributes: { 'class': 'table-cell grid-cell-center' },
                format: '{0:p0}',
            }]
        });

        ValueSwapHelper.showHideFields(MovingAverages.GRID, MovingAverages.PERCENT_FIELDS,
            MovingAverages.DOLLAR_FIELDS);
    }
}
